import React from "react";

export const ArrowLeft = ({ fill, className }) => {
  return (
    <svg
      width="20"
      height="8"
      viewBox="0 0 20 8"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 4H3M3 4L7.5 0.5M3 4L7.5 7.5"
        stroke={fill || "currentColor"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
